<template>
    <div>
        <PageHeader :page="page" :template="'2'" v-if="!state.loading"/>
        <div class="content" v-if="!state.loading">
            <DataTable :tableData="tableData" @view_basic="viewBasic" 
            @edit_basic="editBasic" @edit_month="editMonth" @view_month="viewMonth"/>
        </div>
        <div class="temp-row" v-if="state.loading" style="text-align: center;">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>

    <ModalView
        :isVisible="state.ViewModal"
        :fixclose="true"
        @close="state.ViewModal = false">
        
        <FormView :columns="1"
            :fields="viewFields" :errors="state.errors"
            :loading="state.modalLoading" />
    </ModalView> 

    

    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">
        
        <DynamicForm :columns="1" v-if="!state.modalLoading"  :addMore="'Add Item'"
        :fields="editFields" @submit="updateBasic" @field-removed="deleteItem"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" @sendData="addMoreEditItem"/>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </ModalView> 

    

    <ModalView
        :isVisible="state.editMonthModal"
        :fixclose="true"
        @close="state.editMonthModal = false">
        
        <DynamicForm :columns="1" v-if="!state.modalLoading"  :addMore="'Add Item'"
        :fields="editFields" @submit="updateMonth" @field-removed="deleteMonthItem"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" @sendData="addMoreMonthItem"/>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </ModalView> 

</template>
<script>
import icons from '@/assets/js/icons.js';
import { ref, reactive, onMounted } from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import ModalView from '@/components/ModalView.vue';
import FormView from '@/components/FormView.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import DataTable from '@/components/DataTable.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
export default{
    components:{PageHeader, DataTable,FormView,ModalView,DynamicForm},
    setup(){
        const viewFields=ref([]);
        const editFields=ref([])
        const page=ref({title:"Salary Management", btn:"",
        desc:"Manage the salary of all staff in one page"})
        const state=reactive({loading:true,ViewModal:false,submitting:false,error:[],
            success:false,modalLoading:false, editMonthModal:false, editModal:false})
        
        const itemOptions=ref([
            {label:"Deduction", value:"Deduction"},
            {label:"Allowance", value:"Allowance"}
        ])

        const itemBOptions=ref([
            {label:"Deduction", value:"Deduction"},
            {label:"Bonus", value:"Bonus"},
            {label:"Allowance", value:"Allowance"}
        ])

        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "Staff" },
                { label: "Basic" },
                { label: "This Month's Items" },
                { label: "This Month's Pay" }
            ],
            options:{
                label:"Options",
                action_label:[icons.view,icons.edit,icons.skills,icons.edit2],
                action:["view_basic","edit_basic","view_month","edit_month"]
            },
            total:0
        });

        function setTable(msg){
            var data={}
            tableData.value.loading = false;
            tableData.value.rows.length=0
            Object.keys(msg).forEach(set => {
                data={id:msg[set].id,status:msg[set].status};
                var v=[];
                Object.keys(msg[set].val).forEach(row => {
                v.push(msg[set].val[row])
                });
                data.val=v;
                tableData.value.rows.push(data)
            });
            tableData.value.total=tableData.value.rows.length
        }

        onMounted(() => {
            call({
                url:urls.transactions,
                data:{startSalaryMgt:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        var d=res.msg;
                        setTable(d.staff);
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function viewBasic(i){
            state.modalLoading=true
            state.ViewModal=true;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.transactions,
                data:{viewBasic:id},
                success:(res)=>{
                    if(res.status){
                        viewFields.value.length=0;
                        var d=res.msg,
                        data=[];
                        Object.keys(d).forEach(set => {
                            var v=d[set]
                            data.push(
                                {label: v.name,name: set,
                                    value: v.amount}
                            );
                        })
                        viewFields.value.push(
                                { name: "Salary Breakdown", number: "1",
                                data: data}
                        );
                        state.modalLoading=false;
                    }else{
                        state.modalLoading=false;
                        state.ViewModal=false;
                        alert(res.msg);
                    }
                }
            })
        }

        function editBasic(i){
            state.modalLoading=true
            state.editModal=true;
            state.submitting=false;
            state.success=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.transactions,
                data:{vieweBasic:id},
                success:(res)=>{
                    if(res.status){
                        editFields.value.length=0;
                        var d=res.msg,
                        num=0;
                        Object.keys(d).forEach(set => {
                            var v=d[set]
                            ++num
                            editFields.value.push(
                                { name: "Edit Item", number: num, deletable:true, 
                                    id:v.id, data: 
                                        [{ type: 'text', name: 'name_'+num, label: 'Name',
                                        value: v.name  },
                                        { type: 'select', name: 'type_'+num, label: 'Item type',
                                            value: v.type, options:itemOptions
                                        },
                                        { type: 'text', name: 'amount_'+num, label: 'Amount',
                                        value: v.amount  },
                                        { type: 'hidden', name: 'item_'+num,value: v.id  },
                                        { type: 'hidden', name: 'user_'+num,value: v.user  },
                                        ]
                                }
                            );
                        })
                        if(editFields.value.length==0){
                            num=1;
                            editFields.value.push(
                                { name: "Add Item", number: num,
                                    id:"new", data: 
                                        [{ type: 'text', name: 'name_'+num, label: 'Name',
                                        value: "base",readonly:true  },
                                        { type: 'select', name: 'type_'+num, label: 'Item type',
                                            value: "", options:[
                                                {label:"Base Salary", value:"Allowance"}
                                            ]
                                        },
                                        { type: 'text', name: 'amount_'+num, label: 'Amount',
                                        value: ""  },
                                        { type: 'hidden', name: 'item_'+num,value: "new"  },
                                        { type: 'hidden', name: 'user_'+num,value: id  },
                                        ]
                                }
                            );
                        }
                        state.modalLoading=false;
                    }else{
                        state.modalLoading=false;
                        state.editModal=false;
                        alert(res.msg);
                    }
                }
            })
        }

        function deleteItem({updatedFormSets,  deleted, data }) {
            if(deleted.fieldIndex){
                editFields.value[deleted.setIndex].data[deleted.fieldIndex].deleting=true;
            }else{
                editFields.value[deleted.setIndex].deleting=true;
            }
            
            var id=editFields.value[deleted.setIndex].id;
            if(id=="new"){
                editFields.value=updatedFormSets;
                for(var i=0; i<editFields.value.length; i++){
                    var e=i+1;
                    editFields.value[i].number=e;
                    editFields.value[i].data.forEach(field => {
                    if (data[field.name]) {
                        field.value = data[field.name];
                    }
                    });
                }
            }else{
                call({
                    url:urls.transactions,
                    data:{deletesItem:id},
                    success:(res)=>{
                        if(res.status){
                            editFields.value=updatedFormSets;
                            for(var i=0; i<editFields.value.length; i++){
                                var e=i+1;
                                editFields.value[i].number=e;
                                editFields.value[i].data.forEach(field => {
                                if (data[field.name]) {
                                    field.value = data[field.name];
                                }
                                });
                            }
                            if(editFields.value.length < 1){
                                var num=1;
                                editFields.value.push(
                                    { name: "Add Item", number: num,
                                        id:"new", data: 
                                            [{ type: 'text', name: 'name_'+num, label: 'Name',
                                            value: "base",readonly:true  },
                                            { type: 'select', name: 'type_'+num, label: 'Item type',
                                                value: "", options:[
                                                    {label:"Base Salary", value:"Allowance"}
                                                ]
                                            },
                                            { type: 'text', name: 'amount_'+num, label: 'Amount',
                                            value: ""  },
                                            { type: 'hidden', name: 'item_'+num,value: "new"  },
                                            { type: 'hidden', name: 'user_'+num,value: data['user_1']  },
                                            ]
                                    }
                                );
                            }
                            setTable(res.msg)
                        }else{
                            if(deleted.fieldIndex){
                                editFields.value[deleted.setIndex].data[deleted.fieldIndex].deleting=false;
                            }else{
                                editFields.value[deleted.setIndex].deleting=false;
                            }
                            setErrors(res.msg)
                            setTimeout(()=>{
                                state.errors=[]
                            },5000)
                        }
                    }
                })
            }
        }

        function setErrors(res){
            var errors=[];
            Object.keys(res.msg).forEach(key => {
            var e=res.msg[key],er="";
            Object.keys(e).forEach(k => {
                er+=er=="" ? e[k] : ", "+e[k]
            })
            errors.push(er);
            });
            state.errors=errors;
        }

        function addMoreEditItem(f){
            var user =f["user_1"];
            for(var i=0; i<editFields.value.length; i++){
                editFields.value[i].data.forEach(field => {
                if (f[field.name]) {
                    field.value = f[field.name];
                }
                });
            }
            editFields.value.push(
                { name: "Add Item", number: (editFields.value.length+1).toString(), deletable:true, 
                    data: 
                        [{ type: 'text', name: 'name_'+(editFields.value.length+1).toString(), label: 'Name',
                        value: "",  },
                        { type: 'select', name: 'type_'+(editFields.value.length+1).toString(), label: 'Item type',
                            value: "",options:[
                                {label:"Deduction", value:"Deduction"},
                                {label:"Allowance", value:"Allowance"},
                            ]
                        },
                        { type: 'text', name: 'amount_'+(editFields.value.length+1).toString(), label: 'Amount',
                        value: ""  },
                        { type: 'hidden', name: 'user_'+(editFields.value.length+1).toString(),value: user  },
                        { type: 'hidden', name: 'item_'+(editFields.value.length+1).toString(),value: "new"  },
                        ]
                }
            )
        }

        function updateBasic(data){
            state.submitting=true;
            state.errors=[];
            data.updateBasic=(editFields.value.length).toString();
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg.table);
                    if(res.msg.error != ""){
                        alert(res.msg.error)
                    }
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function editMonth(i){
            state.modalLoading=true
            state.editMonthModal=true;
            state.submitting=false;
            state.success=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.transactions,
                data:{viewMonth:id},
                success:(res)=>{
                    if(res.status){
                        editFields.value.length=0;
                        var d=res.msg,
                        num=0;
                        Object.keys(d).forEach(set => {
                            var v=d[set]
                            ++num
                            editFields.value.push(
                                { name: "Edit Item", number: num, deletable:true, 
                                    id:v.id, data: 
                                        [{ type: 'textarea', name: 'name_'+num, label: 'Name',
                                        value: v.desc  },
                                        { type: 'select', name: 'type_'+num, label: 'Item type',
                                            value: v.type, options:itemBOptions
                                        },
                                        { type: 'text', name: 'amount_'+num, label: 'Amount',
                                        value: v.amount  },
                                        { type: 'hidden', name: 'item_'+num,value: v.id  },
                                        { type: 'hidden', name: 'user_'+num,value: v.user  },
                                        ]
                                }
                            );
                        })
                        if(editFields.value.length==0){
                            num=1;
                            editFields.value.push(
                                { name: "Add Item for this month only", number: num,
                                    id:"new", data: 
                                        [{ type: 'textarea', name: 'name_'+num, label: 'Description',
                                        value: "" },
                                        { type: 'select', name: 'type_'+num, label: 'Item type',
                                            value: "", options:itemBOptions
                                        },
                                        { type: 'text', name: 'amount_'+num, label: 'Amount',
                                        value: ""  },
                                        { type: 'hidden', name: 'item_'+num,value: "new"  },
                                        { type: 'hidden', name: 'user_'+num,value: id  },
                                        ]
                                }
                            );
                        }
                        state.modalLoading=false;
                    }else{
                        state.modalLoading=false;
                        state.editModal=false;
                        alert(res.msg);
                    }
                }
            })
        }

        

        function addMoreMonthItem(f){
            var user =f["user_1"];
            for(var i=0; i<editFields.value.length; i++){
                editFields.value[i].data.forEach(field => {
                if (f[field.name]) {
                    field.value = f[field.name];
                }
                });
            }
            editFields.value.push(
                { name: "Add Item for this month only", number: (editFields.value.length+1).toString(),
                    id:"new", deletable:true, data: 
                        [{ type: 'textarea', name: 'name_'+(editFields.value.length+1).toString(), label: 'Description',
                        value: "",  },
                        { type: 'select', name: 'type_'+(editFields.value.length+1).toString(), label: 'Item type',
                            value: "",options:itemBOptions
                        },
                        { type: 'text', name: 'amount_'+(editFields.value.length+1).toString(), label: 'Amount',
                        value: ""  },
                        { type: 'hidden', name: 'user_'+(editFields.value.length+1).toString(),value: user  },
                        { type: 'hidden', name: 'item_'+(editFields.value.length+1).toString(),value: "new"  },
                        ]
                }
            )
        }

        function deleteMonthItem({updatedFormSets,  deleted, data }) {
            if(deleted.fieldIndex){
                editFields.value[deleted.setIndex].data[deleted.fieldIndex].deleting=true;
            }else{
                editFields.value[deleted.setIndex].deleting=true;
            }
            
            var id=editFields.value[deleted.setIndex].id;
            if(id=="new"){
                editFields.value=updatedFormSets;
                for(var i=0; i<editFields.value.length; i++){
                    var e=i+1;
                    editFields.value[i].number=e;
                    editFields.value[i].data.forEach(field => {
                    if (data[field.name]) {
                        field.value = data[field.name];
                    }
                    });
                }
            }else{
                call({
                    url:urls.transactions,
                    data:{deleteMonthItem:id},
                    success:(res)=>{
                        if(res.status){
                            editFields.value=updatedFormSets;
                            for(var i=0; i<editFields.value.length; i++){
                                var e=i+1;
                                editFields.value[i].number=e;
                                editFields.value[i].data.forEach(field => {
                                if (data[field.name]) {
                                    field.value = data[field.name];
                                }
                                });
                            }
                            if(editFields.value.length < 1){
                                var num=1;
                                editFields.value.push(
                                    { name: "Add Item for this month only", number: num,
                                        id:"new", data: 
                                            [{ type: 'textarea', name: 'name_'+num, label: 'Description',
                                            value: "" },
                                            { type: 'select', name: 'type_'+num, label: 'Item type',
                                                value: "", options:itemBOptions
                                            },
                                            { type: 'text', name: 'amount_'+num, label: 'Amount',
                                            value: ""  },
                                            { type: 'hidden', name: 'item_'+num,value: "new"  },
                                            { type: 'hidden', name: 'user_'+num,value: id  },
                                            ]
                                    }
                                );
                            }
                            setTable(res.msg)
                        }else{
                            if(deleted.fieldIndex){
                                editFields.value[deleted.setIndex].data[deleted.fieldIndex].deleting=false;
                            }else{
                                editFields.value[deleted.setIndex].deleting=false;
                            }
                            setErrors(res.msg)
                            setTimeout(()=>{
                                state.errors=[]
                            },5000)
                        }
                    }
                })
            }
        }

        function updateMonth(data){
            state.submitting=true;
            state.errors=[];
            data.updateMonth=(editFields.value.length).toString();
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg.table);
                    if(res.msg.error != ""){
                        alert(res.msg.error)
                    }
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function viewMonth(i){
            state.modalLoading=true
            state.ViewModal=true;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.transactions,
                data:{viewsMonth:id},
                success:(res)=>{
                    if(res.status){
                        viewFields.value.length=0;
                        var d=res.msg,
                        data=[];
                        Object.keys(d).forEach(set => {
                            var v=d[set]
                            data.push(
                                {label: v.name,name: set,
                                    value: v.amount}
                            );
                        })
                        viewFields.value.push(
                                { name: "This month's item", number: "1",
                                data: data}
                        );
                        state.modalLoading=false;
                    }else{
                        state.modalLoading=false;
                        state.ViewModal=false;
                        alert(res.msg);
                    }
                }
            })
        }

        return {page,tableData,state,viewBasic,viewFields,editBasic,editFields,addMoreMonthItem,
        deleteItem,addMoreEditItem,updateBasic,editMonth,deleteMonthItem,viewMonth,
        updateMonth}
    }
}
</script>